import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Blue } from '../../themes/blue/colorPalette';

const PageButtonsContainer = styled(Box)(({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 32,
    padding: '0px 8px',
    backgroundColor: 'white',
    boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.05)',
    '& .MuiIconButton-root': {
        padding: 8,
        margin: 2,
        '& .MuiSvgIcon-root': {
            fill: Blue[2],
            '&:hover': {
                fill: Blue[3]
            }
        },
        '&:hover': {
            backgroundColor: theme.palette.grey[10]
        },
        '&.Mui-disabled': {
            '& .MuiSvgIcon-root': {
                fill: theme.palette.grey[9]
            }
        }
    },
    '& .MuiDivider-root': {
        marginLeft: 4,
        marginRight: 4,
        backgroundColor: theme.palette.grey[10]
    }
}));

export default PageButtonsContainer;
